import React, { useState, useEffect } from "react";

import { auth } from "../../firebase";

import functionsService from "../../services/functionsService";

import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "../../components/ui/dialog";

import { Label } from "../../components/ui/label";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";

import { useToast } from "../../components/hooks/use-toast";

export default function ProjectJoinModal({ modalOpen, setModalOpen }) {
  const [inviteToken, setInviteToken] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [isChecking, setIsChecking] = useState(false);

  const { toast } = useToast();

  // Validate fields on input change
  useEffect(() => {
    if (inviteToken.length > 0) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }, [inviteToken]);

  const clearModal = () => {
    setInviteToken("");
  };

  const handleCancel = () => {
    clearModal();
    setModalOpen(false);
  };

  const handleSubmit = async () => {
    try {
      setIsChecking(true);

      const { success, error } = await functionsService.validateInvite(
        inviteToken,
        undefined,
        auth.currentUser.uid
      );

      if (!success) {
        console.error("Error validating the invite code.", error);

        toast({
          variant: "destructive",
          title: "Error validating the invite code.",
          description: error.message,
        });

        return;
      }

      toast({
        title: "Successfully joined project",
        description: "You are now a member of the project.",
      });

      clearModal();
      setModalOpen(false);
    } catch (error) {
      console.error("Error validating the invite code.", error);

      toast({
        variant: "destructive",
        title: "Error validating the invite code.",
        description: error.message,
      });
    } finally {
      setIsChecking(false);
    }
  };

  const styles = {
    submitButton: {
      minWidth: "100px",
    },

    spinner: {
      border: "4px solid #f3f3f3",
      borderTop: "4px solid #282c34",
      borderRadius: "50%",
      width: "20px",
      height: "20px",
      animation: "spin 1s linear infinite",
    },
  };

  return (
    <Dialog open={modalOpen} onOpenChange={setModalOpen}>
      <DialogContent>
        <DialogTitle>Join Project</DialogTitle>

        <DialogDescription>
          Enter the invite code provided to join the associated project.
        </DialogDescription>

        <div className="space-y-4">
          <div>
            <Label htmlFor="inviteToken">Invite Code</Label>

            <Input
              id="inviteToken"
              type="text"
              value={inviteToken}
              onChange={(e) => setInviteToken(e.target.value)}
              placeholder="Enter invite code"
              disabled={isChecking}
            />
          </div>
        </div>

        <DialogFooter className="mt-4">
          <Button
            variant="outline"
            disabled={isChecking}
            onClick={handleCancel}
          >
            Cancel
          </Button>

          <Button
            disabled={!isValid || isChecking}
            onClick={handleSubmit}
            style={styles.submitButton}
          >
            {isChecking ? <div style={styles.spinner}></div> : "Join"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
